import React, { useState, useEffect } from "react";
import * as styles from "../../../newStyles.styles";
import { withRedux, priceToDollars } from "helpers";
import LoginSignup from "../../../Authentication/LoginSignup";
import DeliveryOptions from "./CheckoutUtil/DeliveryOptions";
import CheckoutForm from "./CheckoutUtil/CheckoutForm";
import CheckoutIcon from "./CheckoutUtil/CheckoutIcon";
import BillingDetailsFields from "./CheckoutUtil/BillingDetailsFields";
import { isMobileDevice } from "helpers";
import styled, { css } from "react-emotion";
import {
  addAddressForUser,
  getUserAddresses,
  getStripeCustomerCards,
  validateDeliveryAddressOnly,
} from "apis";
import Modal from "@material-ui/core/Modal";
import GuestSignup from "../../../Authentication/GuestSignup";
import { TextField, Tooltip } from "@material-ui/core";
import HelpTwoToneIcon from "@material-ui/icons/HelpTwoTone";
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";

const CheckoutContainer = styled("div")`
  margin: 0 auto;
  max-width: 92.30769rem;
  width: 100%;
  min-height: 15.38462rem;
  padding: 0 1.5rem 7.5rem;
  @media (min-width: 968px) {
    padding-bottom: 1.5rem;
  }
`;

const OptionContainer = styled("div")`
  border-radius: 8px;
  border: ${(props) =>
    props.selected ? "2px solid " + props.color : "1px solid #dadada"};
  background-color: #f3f5f6;
  margin: 10px 0 20px;
  cursor: pointer;
  padding: 10px;
  width: 100%;
`;

const CheckoutMain = styled("div")`
  padding-left: 1.15385rem;
  padding-right: 1.15385rem;
  width: 100%;
  float: left;
  @media (min-width: 1261px) {
    padding-right: 2rem;
  }
  @media (min-width: 1261px) {
    width: 66.66667%;
  }
  @media (min-width: 968px) {
    width: 58.33333%;
  }

  @media only screen and (max-width: 768px) {
    padding-left: 0rem;
    padding-right: 0rem;
  }
`;

const CheckoutList = styled("ol")`
  counter-reset: li-counter;
  list-style-type: none;
  margin: 0;

  margin-left: 1.4rem;
  ul,
  ol,
  dl {
    font-family: inherit;
    font-size: 1rem;
    line-height: 1.5;
    list-style-position: outside;
    margin-bottom: 1.5rem;
  }
  @media only screen and (max-width: 768px) {
    margin-left: 0rem;
  }
`;

const CheckoutStep = styled("li")`
  border-color: #ddd;
  border-bottom: 1px solid #ebebeb;
  padding: 1.5rem 0;
  :last-child {
    border: 0;
  }
`;

const StepHeader = styled("div")`
  align-items: center;
  display: flex;
  height: 2.69231rem;
  margin-right: 1.5rem;
  margin-bottom: 1.5rem;
`;

const AsideSummary = styled("aside")`
  @media (min-width: 968px) {
    width: 41.66667%;
  }

  padding-left: 1.15385rem;
  padding-right: 1.15385rem;
  width: 100%;
  float: left;
`;

const ArticleSummary = styled("article")`
  background-color: #fff;
  border-color: #ddd;
  box-shadow: 0 1px 4px rgba(221, 221, 221, 0.6);

  @media (min-width: 968px) {
    display: block;
  }

  border: 1px solid #ebebeb;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(95, 95, 95, 0.14);
  /* display: none; */
  margin: 3rem 0 1.5rem;
  min-height: 300px;
`;

const ArticleHeader = styled("header")`
  display: table;
  padding: 1.5rem;
  width: 100%;
`;

const Section = styled("section")`
  border-top: 1px solid #ebebeb;
  padding: 1.5rem;
  border-color: #ddd;
`;

const SectionRow = styled("div")`
  display: table;
  margin-bottom: 0.75rem;
  width: 100%;
`;

const SectionItem = styled("div")`
  display: table-cell;
  vertical-align: middle;
`;

const SubmitButton = styled("button")`
  display: block;
  height: 40px;
  width: 100%;
  font-size: inherit;
  font-weight: bold;
  background-color: ${(props) => (props.disabled ? "#7795f8" : props.color)};
  border: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  border-radius: 4px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  color: #fff;
  cursor: pointer;
  margin-top: 20px;
`;

const Title = styled("p")`
  text-align: left;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 1.17em;
`;

const FlexBetween = styled("div")`
  display: flex;
  justify-content: space-between;
`;

const flexCol = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
`;

const flexColumn = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Clickable = styled("a")`
  display: table-cell;
  text-align: right;
  vertical-align: middle;
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;
`;

const AddressRow = styled("div")`
  width: 100%;
  padding: 9px;
  border: 1px solid #fff;
`;
const AddressLabel = styled("label")`
  position: relative;
  font-weight: 400;
  padding-left: 15px;
  text-indent: -15px;
  margin-left: 3px;
  top: -2px;
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
  :last-child {
    margin-bottom: 0;
  }
`;

const AddressRadio = styled("input")`
  height: 14px;
  width: 14px;
  vertical-align: top;
  position: relative;
  bottom: -3px;
  transition: all 0.1s linear;
  margin-right: 5px;
`;

const AddAddressIcon = styled("img")`
  width: 16px;
  vertical-align: top;
  max-width: 100%;
  border: 0;
  margin-right: 10px;
`;

export const inputStyle = css`
  width: 65%;
  border: none;
  border-bottom: 1px solid #1f3747;
  background: none;
  outline: none;
  color: black;
  padding: 5px;
  box-shadow: none;
  font-size: 1em;
  margin: 8px;
  transition: opacity 0.2s;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: #1f3747;
    font-size: 1em;
    opacity: 0.8;
  }
`;

const accountText = `Please enter the customer information for this order. You may checkout as guest, or create an account for faster checkout in the future.`;

const useStyles = makeStyles((theme) => ({
  customWidth: {
    maxWidth: 300,
    fontSize: "14px",
  },
  root: {
    textAlign: "left",
  },
  textField: {
    width: "100%",
    margin: theme.spacing(1),
  },
}));

function CheckoutWebComponent(props) {
  // console.log("CHECKOUT PROPS");
  // console.dir(props);
  const {
    platformInfo: {
      status: { user },
    },
    cart,
    isAdmin,
  } = props;
  const isAnonUser = user ? user.tempUser : true;
  const cartIsEmpty = cart.cartQty === 0;
  const isDelivery = cart.orderDeliveryType === "DELIVERY";

  let userNeeded = cart.orderCustomerInfo
    ? cart.orderCustomerInfo.firstName === "" &&
      cart.orderCustomerInfo.lastName === "" &&
      cart.orderCustomerInfo.email === "" &&
      cart.orderCustomerInfo.phone === "" &&
      !cartIsEmpty
    : true;
  const classes = useStyles();

  const [showAddressModal, setShowAddressModal] = useState(false);
  const [edit, setEdit] = useState(false);

  const [showAddressOptions, setShowAddressOptions] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [userCards, setUserCards] = useState([]);
  const [selectedCardPayment, setSelectedCardPayment] = useState(null);
  const [tempAddress, setTempAddress] = useState({
    city: "",
    streetAddress: "",
    state: "",
    zip: "",
    aptSuiteNumber: "",
    latitude: "",
    longitude: "",
    googlePlacesId: "",
  });

  const [isValidDeliveryAddress, setIsValidDeliveryAddress] = useState(false);

  // console.log("printing temp address");
  // console.dir(tempAddress);
  // console.log(cart.orderDeliveryType);

  // console.log("!!!!!! printing cart address");
  // console.dir(cart.address);

  const isMob = isMobileDevice();

  const invalidCustomerInfo = () => {
    let error = "";
    if (cart.orderCustomerInfo.firstName === "") {
      error = "First name for customer info cannot be blank.";
    } else if (cart.orderCustomerInfo.lastName === "") {
      error = "Last name for customer info cannot be blank.";
    } else if (cart.orderCustomerInfo.email === "") {
      error = "Email for customer info cannot be blank.";
    } else if (cart.orderCustomerInfo.phone === "") {
      error = "Phone number for customer info cannot be blank.";
    }
    if (error != "") {
      return true;
    } else {
      return false;
    }
  };

  const goToCart = () => {
    props.actions.setTemplate(props.activeApp.id, null);
    props.history.push({
      pathname: `/${props.activeApp.landingPagePath}/home`,
      state: { path: "cart" },
    });
  };

  const getCards = async () => {
    if (!user.stripeCustomerId) return;

    const cards = await getStripeCustomerCards(user.id).then((res) => res.data);

    // const cards = RawCards;
    // console.log("SUCCESS!: got cards from stripe!");
    // console.dir(cards);
    setUserCards(cards);
    setSelectedCardPayment(cards.length > 0 ? cards[0] : null);
  };

  useEffect(() => {
    getUserAddies();
    getCards();
  }, [user]);

  useEffect(() => {
    if (cart.orderDeliveryType) {
      props.actions.updateClientTotal(
        cart.deliveryCost + cart.clientCalculatedSubtotal
      );
    }
  }, [cart.orderDeliveryType]);

  useEffect(() => {}, [cart.orderDeliveryAddressId]);

  const validateOnUpdate = async () => {
    try {
      const valid = await validateDeliveryAddressOnly(
        props.activeApp.id,
        cart.address
      ).then((res) => {
        // console.log("Validation success\nResult: ");
        // console.dir(res);
        if (res != true) {
          // console.error("tej address is NOT validated")
          setIsValidDeliveryAddress(false);
          return;
        } else {
          // console.error("tej address is validated")
          setIsValidDeliveryAddress(true);
          if (showAddressModal === true) {
            toggleAddressModal();
          }
        }
      });
    } catch (e) {
      // console.error("tej validate address catch error")
      setIsValidDeliveryAddress(false);
      // console.error(e);
    }
  };

  useEffect(() => {
    if (isDelivery && cart.address) {
      // console.log("checking for valid delivery address...");
      // console.dir(cart.address);
      validateOnUpdate();
    }
  }, [cart.orderDeliveryType, cart.address]);

  const update = (field) => (value) => {
    let newVal = value.target.value;
    const updatedCustomerInfo = {
      ...cart.orderCustomerInfo,
      [field]: newVal,
    };

    props.actions.updateCustomerInfo(updatedCustomerInfo);
  };

  const toggleAddressModal = (edit) => {
    setShowAddressModal(!showAddressModal);
    if (edit) setEdit(true);
    else setEdit(false);
  };

  const toggleAddressOptions = () => {
    setShowAddressOptions(!showAddressOptions);
    getUserAddies();
  };

  const addAddressHelperFunc = async () => {
    const userId = user.id;
    try {
      const addressResult = await addAddressForUser(userId, tempAddress).then(
        (res) => {
          // console.log(res);
          // props.actions.updateAddress(res.id);
          // props.actions.updateAddressObject(res);
          // console.error("tej: successfully added users addy, now fetching them")
          getUserAddies();
        }
      );
      // console.error("tej not closing modal")
      // toggleAddressModal();
      toggleAddressOptions();
      setTempAddress({
        city: "",
        streetAddress: "",
        state: "",
        zip: "",
        aptSuiteNumber: "",
        latitude: "",
        longitude: "",
        googlePlacesId: "",
      });
    } catch (e) {
      // console.error("tej: error added users addy, now fetching them")
      console.error(e);
    }
  };

  const handleAddAddress = async (event) => {
    // console.error("tej handling add address. is delivery: " + isDelivery)
    if (!showAddressOptions) return;
    event.preventDefault();

    try {
      if (isDelivery) {
        // console.log("validating delivery address....");
        const valid = await validateDeliveryAddressOnly(
          props.activeApp.id,
          tempAddress
        ).then((res) => {
          // console.log("Validation success\nResult: ");
          if (res != true) {
            // console.error("tej add address not valid")
            // console.dir(res);
            setIsValidDeliveryAddress(false);
            return;
          } else {
            // console.error("tej add address is valid")
            setIsValidDeliveryAddress(true);
            addAddressHelperFunc();
          }
        });
      } else {
        addAddressHelperFunc();
      }
    } catch (e) {
      console.error(e);
    }
  };

  const validateDeliveryAddressBeforeCheckout = async (event) => {
    event.preventDefault();
    if (isDelivery) {
      try {
        // console.log("validating delivery address....");
        const valid = await validateDeliveryAddressOnly(
          props.activeApp.id,
          cart.address
        ).then((res) => {
          // console.log("Validation success\nResult: ");
          if (res != true) {
            // console.dir(res);
            setIsValidDeliveryAddress(false);
            return;
          } else {
            setIsValidDeliveryAddress(true);
            toggleAddressModal();
          }
        });
      } catch (e) {
        console.error(e);
      }
    } else {
      toggleAddressModal();
    }
  };

  const getUserAddies = async () => {
    const userId = user.id;
    try {
      const addresses = await getUserAddresses(userId);
      setAddresses(addresses);
      // setAddresses([]); // debug for no addresses
      // set a default address if there isnt one
      // if (!cart.orderDeliveryAddressId && addresses.length > 0) {
      //   props.actions.updateAddress(addresses[addresses.length - 1].id);
      //   props.actions.updateAddressObject(addresses[addresses.length - 1]);
      // }
    } catch (e) {
      console.error(e);
    }
  };

  const renderAddressInput = () => {
    let editAddress = null;
    if (edit) {
      editAddress = addresses.find((a) => a.id === cart.orderDeliveryAddressId);
    }
    if (!showAddressOptions) return null;
    return (
      <Modal
        open={showAddressOptions}
        onClose={toggleAddressOptions}
        style={{
          width: isMob ? "95%" : "50%",
          marginLeft: "auto",
          marginRight: "auto",
          height: "fit-content",
          position: "fixed",
          bottom: "30%",
          left: "0",
          top: "auto",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            height: "400px",
            backgroundColor: "#fff",
            padding: "1em",
            color: "black",
            overflowY: "auto",
          }}
        >
          <a style={{ cursor: "pointer" }} onClick={toggleAddressOptions}>
            X
          </a>
          <form onSubmit={handleAddAddress} style={{ margin: "15px 0" }}>
            {/* <Title>
              {edit ? "Update your address" : "Enter a new address"}
            </Title> */}
            <BillingDetailsFields
              omitNameAndEmail={true}
              edit={editAddress}
              setTempAddress={setTempAddress}
              tempAddress={tempAddress}
            />
            <SubmitButton
              color={props.activeApp.view.navigation.navBarColor}
              disabled={tempAddress.googlePlacesId === ""}
            >
              {edit ? "Save changes" : "Add Address"}
            </SubmitButton>
          </form>
        </div>
      </Modal>
    );
  };
  const renderContactInfo = () => {
    if (!user) return;
    if (userNeeded && user.tempUser === 1)
      return (
        <div>
          <StepHeader>
            <CheckoutIcon iconName={"one"} />
            <div style={{ display: "flex", alignItems: "center" }}>
              <styles.H5
                style={{
                  margin: "0 0.5rem 0 1.5rem",
                  textAlign: "left",
                }}
              >
                {" "}
                Customer{" "}
              </styles.H5>

              <Tooltip
                title={accountText}
                classes={{ tooltip: classes.customWidth }}
              >
                <HelpTwoToneIcon color="primary" fontSize="small" />
              </Tooltip>
            </div>
          </StepHeader>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              color: props.activeApp.view.navigation.navBarColor,
              margin: "10px 0px",
            }}
          >
            <span
              style={{
                color: "black",
                margin: "8px 0px",
                fontSize: "0.875rem",
              }}
            >
              Already have an account ?{" "}
            </span>
            <LoginSignup
              split={true}
              isWeb={true}
              customColor={true}
              loginOnly={true}
            />
          </div>
          <GuestSignup
            buttonText={"Continue"}
            customColor={props.activeApp.view.navigation.navBarColor}
          />

          <p style={{ color: "black", margin: "10px 0px", fontSize: "14px" }}>
            By using this website, you're agreeing to our{" "}
            <a style={{ cursor: "pointer" }} href="/terms" target="_blank">
              Terms & Conditions
            </a>{" "}
            and{" "}
            <a
              style={{ cursor: "pointer" }}
              href="/privacy_policy"
              target="_blank"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      );
    else
      return (
        <div>
          <StepHeader>
            <CheckoutIcon iconName={"checkmark"} />
            <styles.H5 style={{ margin: "0 0 0 1.5rem", minWidth: "9rem" }}>
              {" "}
              Customer
            </styles.H5>
          </StepHeader>
          <div
            style={{
              marginTop: "50px",
              padding: "0px 15px 0px 78px",
              alignSelf: "center",
              backgroundColor: "white",
            }}
          >
            <form className={flexColumn}>
              <div className={flexCol}>
                <input
                  className={inputStyle}
                  autoFocus="firstName"
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={cart.orderCustomerInfo.firstName}
                  onChange={update("firstName")}
                  required
                />
                <br />
                <input
                  className={inputStyle}
                  autoFocus="lastName"
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={cart.orderCustomerInfo.lastName}
                  onChange={update("lastName")}
                  required
                />
                <br />
                <input
                  className={inputStyle}
                  autoFocus="email"
                  type="text"
                  name="email"
                  placeholder="Email"
                  value={cart.orderCustomerInfo.email}
                  onChange={update("email")}
                  required
                />

                <br />
                <input
                  className={inputStyle}
                  autoFocus="phone"
                  type="text"
                  name="phone"
                  placeholder="Phone"
                  value={cart.orderCustomerInfo.phone}
                  onChange={update("phone")}
                  required
                />
              </div>
            </form>
          </div>
        </div>
      );
  };

  String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  const renderTotalCalcs = () => {
    const { cart } = props;
    // if (!cart.orderDeliveryType) return null;

    return (
      <AsideSummary>
        <ArticleSummary>
          <ArticleHeader>
            <h3
              style={{
                display: "table-cell",
                marginBottom: "0",
                verticalAlign: "middle",
                textAlign: "left",
              }}
            >
              Order Summary
            </h3>
            <Clickable onClick={goToCart}>Edit Cart</Clickable>
          </ArticleHeader>
          <Section>
            <SectionRow>
              <SectionItem style={{ textAlign: "left" }}>Subtotal</SectionItem>
              <SectionItem style={{ textAlign: "right" }}>
                {priceToDollars(cart.clientCalculatedSubtotal)}
              </SectionItem>
            </SectionRow>
            {cart.orderDeliveryType != "PICKUP" && cart.deliveryCost > 0 && (
              <SectionRow>
                <SectionItem style={{ textAlign: "left" }}>
                  {cart.orderDeliveryType.toProperCase()}
                </SectionItem>
                <SectionItem style={{ textAlign: "right" }}>
                  {" "}
                  {priceToDollars(cart.deliveryCost)}
                </SectionItem>
              </SectionRow>
            )}
            <SectionRow>
              <SectionItem style={{ textAlign: "left" }}>
                Promo Code
              </SectionItem>
              <SectionItem style={{ textAlign: "right" }}>
                <TextField
                  // type="text"
                  disabled={true}
                  style={{ width: "95px" }}
                ></TextField>
              </SectionItem>
            </SectionRow>
            <SectionRow>
              <SectionItem style={{ fontSize: "12px" }}>
                Have a promo code? Use them exclusively on our mobile app. Click{" "}
                <a
                  href={props.activeApp.deeplinkUrl}
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  here
                </a>{" "}
                to download.
              </SectionItem>
            </SectionRow>
          </Section>
          <Section>
            <SectionRow>
              <SectionItem style={{ textAlign: "left" }}>Total</SectionItem>
              <SectionItem
                style={{
                  textAlign: "right",
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  lineHeight: "1.2",
                }}
              >
                {" "}
                {cart.orderDeliveryType
                  ? priceToDollars(cart.clientTotal)
                  : priceToDollars(cart.clientCalculatedSubtotal)}
              </SectionItem>
            </SectionRow>
          </Section>
        </ArticleSummary>
      </AsideSummary>
    );
  };

  String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  // TODO: Render stripe cards
  const renderCards = () => {
    if (userCards.length === 0 || userCards === null) {
      return null;
    }

    // console.log("the selected card is: ");
    // console.dir(selectedCardPayment);

    return (
      <div>
        {userCards.map((card) => {
          // console.dir(card);
          return (
            <div style={{ display: "flex" }}>
              <Radio
                type="radio"
                id={card.id}
                name="cardOption"
                color="primary"
                value={card.id}
                style={{ marginRight: "10px" }}
                checked={selectedCardPayment === card}
                onChange={() => setSelectedCardPayment(card)}
              />
              <OptionContainer
                onClick={() => setSelectedCardPayment(card)}
                selected={selectedCardPayment === card}
                color={props.activeApp.view.navigation.navBarColor}
              >
                <span>
                  <p style={{ fontWeight: "bold" }}>
                    {card.card.brand.toProperCase()} ****{card.card.last4}
                  </p>

                  <p>{card.billing_details.name}</p>

                  <p style={{ color: "#888" }}>
                    {/* expired color #900 */}
                    Expires {card.card.exp_month}/{card.card.exp_year}
                  </p>
                </span>
              </OptionContainer>
            </div>
          );
        })}
        {/* {JSON.stringify(userCards)} */}
        <div style={{ display: "flex" }}>
          <Radio
            type="radio"
            id={null}
            name="cardOption"
            color="primary"
            value={null}
            style={{ marginRight: "10px" }}
            checked={selectedCardPayment === null}
            onChange={() => setSelectedCardPayment(null)}
          />
          <OptionContainer
            onClick={() => setSelectedCardPayment(null)}
            selected={selectedCardPayment === null}
            color={props.activeApp.view.navigation.navBarColor}
          >
            <span>Use New Card</span>
          </OptionContainer>
        </div>
      </div>
    );
  };

  const renderStripeForm = () => {
    if (userNeeded) return null;
    const { cart, webStore, activeApp } = props;
    const { user } = props.platformInfo.status;

    const reqBody = {
      userId: user ? user.id : null,
      appId: activeApp.id,
      templateId: webStore.options.templateId,
      ...cart,
    };

    // console.dir(activeApp.view.navigation.navBarColor);
    return (
      <CheckoutForm
        reqBody={reqBody}
        user={user}
        navColor={activeApp.view.navigation.navBarColor}
        history={props.history}
        selectedCardPayment={selectedCardPayment}
        isAdmin={isAdmin}
        isValidDeliveryAddress={isValidDeliveryAddress}
      />
    );
  };

  const handleAddressChange = (event) => {
    const newAddy = addresses.find(
      (a) => a.id === parseInt(event.target.value)
    );
    props.actions.updateAddress(parseInt(event.target.value));
    props.actions.updateAddressObject(newAddy);
    setIsValidDeliveryAddress(false);
  };

  const renderAddressModal = () => {
    if (!showAddressModal) return null;
    return (
      <Modal
        open={showAddressModal}
        onClose={toggleAddressModal}
        style={{
          width: isMob ? "95%" : "50%",
          marginLeft: "auto",
          marginRight: "auto",
          height: "fit-content",
          position: "fixed",
          bottom: "30%",
          left: "0",
          top: "auto",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            height: "400px",
            backgroundColor: "#fff",
            padding: "1em",
            color: "black",
            overflowY: "auto",
          }}
        >
          <Title>Your addresses</Title>
          <div>
            {addresses.map((a) => {
              return (
                <AddressRow key={a.id}>
                  <AddressLabel>
                    <div>
                      <AddressRadio
                        type="radio"
                        checked={cart.orderDeliveryAddressId === a.id}
                        onChange={handleAddressChange}
                        value={a.id}
                      ></AddressRadio>
                      <span style={{ marginRight: "20px" }}>
                        {a.fullAddress}
                      </span>
                    </div>

                    {/* <Clickable onClick={() => toggleAddressModal(true)}>
                              Edit address
                            </Clickable> */}
                  </AddressLabel>
                </AddressRow>
              );
            })}

            <div style={{ marginTop: "10px" }}>
              <Clickable
                onClick={toggleAddressOptions}
                style={{ marginTop: "10px" }}
              >
                <AddAddressIcon
                  src={
                    "https://mobile360-assets.s3.us-east-2.amazonaws.com/checkout/add.png"
                  }
                />
                Add a New Address
              </Clickable>
            </div>

            {showAddressOptions && renderAddressInput()}

            {!showAddressOptions && (
              <SubmitButton
                onClick={validateDeliveryAddressBeforeCheckout}
                color={props.activeApp.view.navigation.navBarColor}
              >
                Use this Address
              </SubmitButton>
            )}
          </div>
        </div>
      </Modal>
    );
  };

  const renderDeliveryOptions = () => {
    const isPickup = cart.orderDeliveryType === "PICKUP";

    const getIcon = () => {
      if (
        isPickup ||
        (cart.orderDeliveryAddressId &&
          !showAddressOptions &&
          cart.orderDeliveryType &&
          !userNeeded)
      ) {
        return "checkmark";
      }
      return "two";
    };
    const chooseString =
      "Choose a " + cart.orderDeliveryType.toLowerCase() + " address";
    const addressString = cart.orderDeliveryType.toProperCase() + " Address";
    const current = addresses.find((a) => a.id === cart.orderDeliveryAddressId);
    // console.log("GOT CURRENT ADDY");
    // console.dir(current);

    return (
      <div>
        {renderAddressModal()}
        <StepHeader>
          <CheckoutIcon iconName={getIcon()} />
          <styles.H5
            style={{
              margin: "0 0 0 1.5rem",
              minWidth: "9rem",
              textAlign: "left",
            }}
          >
            {" "}
            Select Option
          </styles.H5>
        </StepHeader>
        {!userNeeded && !invalidCustomerInfo() && (
          <div>
            <DeliveryOptions toggleAddressModal={toggleAddressModal} />
            {!isPickup && cart.orderDeliveryType && (
              <OptionContainer
                selected={true}
                color={
                  (isDelivery && !isValidDeliveryAddress && cart.address) ||
                  cart.address === null
                    ? "red"
                    : "green"
                }
                style={{ marginTop: "2rem", padding: "20px" }}
              >
                <FlexBetween>
                  <styles.H5
                    style={{
                      minWidth: "9rem",
                      textAlign: "left",
                      marginTop: "0px",
                    }}
                  >
                    {" "}
                    {showAddressOptions ? chooseString : addressString}{" "}
                  </styles.H5>
                  {cart.orderDeliveryAddressId && addresses.length != 0 && (
                    <span>
                      <Clickable onClick={() => toggleAddressModal(false)}>
                        {showAddressOptions ? "Close" : "Change"}
                      </Clickable>
                    </span>
                  )}
                </FlexBetween>

                <p
                  style={{
                    textAlign: "left",
                    color: "black",
                    fontSize: "16px",
                  }}
                >
                  {current ? current.fullAddress : ""}
                </p>
                {isDelivery && !isValidDeliveryAddress && cart.address && (
                  <p
                    style={{
                      textAlign: "left",
                      color: "red",
                    }}
                  >
                    Invalid Address. Please change.
                  </p>
                )}

                {addresses.length === 0 && (
                  <div style={{ marginTop: "10px" }}>
                    <Clickable
                      onClick={() => toggleAddressModal(false)}
                      style={{ marginTop: "10px" }}
                    >
                      <AddAddressIcon
                        src={
                          "https://mobile360-assets.s3.us-east-2.amazonaws.com/checkout/add.png"
                        }
                      />
                      Add a New Address
                    </Clickable>
                  </div>
                )}
              </OptionContainer>
            )}
          </div>
        )}
      </div>
    );
  };

  // console.log("user needed: " + userNeeded);
  const renderBilling = () => {
    const { cart } = props;

    const noDeliveryType = !cart.orderDeliveryType;
    const isPickup = cart.orderDeliveryType === "PICKUP";
    const renderStripeForPickup = isPickup && !userNeeded;
    const renderStripeForShippingDelivery =
      !userNeeded &&
      !isPickup &&
      cart.orderDeliveryType &&
      cart.orderDeliveryAddressId;
    // console.log("rendering stripe for pickup: " + renderStripeForPickup);

    return (
      <div>
        {" "}
        <StepHeader>
          <CheckoutIcon iconName={"three"} />
          <styles.H5
            style={{
              margin: "0 0 0 1.5rem",
              minWidth: "9rem",
              textAlign: "left",
            }}
          >
            {" "}
            Billing
          </styles.H5>
        </StepHeader>
        {(renderStripeForPickup || renderStripeForShippingDelivery) &&
          renderCards()}
        {(renderStripeForPickup || renderStripeForShippingDelivery) &&
          renderStripeForm()}
      </div>
    );
  };

  return (
    <CheckoutContainer>
      <styles.H3 style={{ margin: "0px", marginBottom: "20px" }}>
        Checkout
      </styles.H3>
      <CheckoutMain>
        <CheckoutList>
          <CheckoutStep> {renderContactInfo()}</CheckoutStep>

          <CheckoutStep> {renderDeliveryOptions()}</CheckoutStep>

          <CheckoutStep> {renderBilling()}</CheckoutStep>
        </CheckoutList>

        {/* {renderPurchaseButton()} */}
      </CheckoutMain>
      {renderTotalCalcs()}
    </CheckoutContainer>
  );
}

export default withRedux(CheckoutWebComponent);
